import { Configuration } from '@azure/msal-browser'
import { environment } from '../../environments/environment'

export const config: Configuration = {
	auth: {
		clientId:
			environment.msalClientId || '7e92dd66-de8d-4d83-b680-a23799e65db0',
		authority:
			environment.msalAuthority ||
			'https://login.microsoftonline.com/e2f449a1-4cf6-43e3-911c-74f3ca9744f3',
		redirectUri: environment.msalRedirectUri || 'http://localhost:4200',
		// protocolMode: ProtocolMode.AAD,
	},
	cache: { cacheLocation: 'localStorage' },
}
